import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { PriorAuthQueueComponent } from '../../prior-auth-queue/prior-auth-queue.component';
import { DraftEformsQueueComponent } from '../../eform-queues/draft-eforms-queue/draft-eforms-queue.component';
import { SubmittedEformsQueueComponent } from '../../eform-queues/submitted-eforms-queue/submitted-eforms-queue.component';

@Component({
  selector: 'app-pharmacy-benefit-manager-dashboard',
  templateUrl: './pharmacy-benefit-manager-dashboard.component.html',
  styleUrls: ['./pharmacy-benefit-manager-dashboard.component.scss'],
  imports: [
    MatCardModule,
    MatTabsModule,
    PriorAuthQueueComponent,
    DraftEformsQueueComponent, 
    SubmittedEformsQueueComponent,
  ],
})
export class PharmacyBenefitManagerDashboardComponent {
  selectedTabIndex: number;
  @Input() redirectToTabIndex: number;
}
